var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottle = function SvgBottle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4378_13738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 1.25L18.75 3.75",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8748 1.875L11.8748 5.625L8.74981 6.25L2.24122 12.7586C2.12511 12.8747 2.03301 13.0125 1.97018 13.1642C1.90734 13.3158 1.875 13.4784 1.875 13.6426C1.875 13.8068 1.90734 13.9693 1.97018 14.121C2.03301 14.2727 2.12511 14.4105 2.24122 14.5266L5.47325 17.7586C5.58933 17.8747 5.72714 17.9668 5.87881 18.0296C6.03049 18.0925 6.19306 18.1248 6.35723 18.1248C6.52141 18.1248 6.68398 18.0925 6.83565 18.0296C6.98733 17.9668 7.12514 17.8747 7.24122 17.7586L13.7498 11.25L14.3748 8.125L18.1248 3.125",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L12.5 12.5",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 16.875L3.125 11.875",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4378_13738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgBottle;